import React from 'react';

const InputText: React.FunctionComponent<
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >
> = (props) => (
  <input
    style={{ cursor: `text` }}
    className="form-input input-lg"
    {...props}
  />
);

export default InputText;
